module.exports = __webpack_public_path__ + "static/img/wakabayashi.57d23f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/wakabayashi.png
// module id = nRaw
// module chunks = 0